module.exports = __webpack_public_path__ + "static/media/on-PlayStore.8b80b5be.svg";